import { Typography } from '@mui/material';
import { colorTokens, typographyTokens } from '../app/designTokens';
import {
  canonicalPasswordFailureI18nKeys,
  canonicalPasswordFailures,
} from '../utils/canonicalPassword';

const { semantic } = colorTokens;

export function PasswordPolicyHints({ password, confirmation, t }) {
  const failures = canonicalPasswordFailures(password, confirmation);
  if (failures.length === 0) {
    return null;
  }

  const labels = canonicalPasswordFailureI18nKeys(failures).map((key) => t(key));

  return (
    <Typography
      component="div"
      sx={{
        fontFamily: typographyTokens.fontFamily,
        fontSize: 12,
        lineHeight: '16px',
        letterSpacing: '0.24px',
        color: semantic.error,
      }}
    >
      {t('validation:password_policy_intro')} {labels.join(', ')}
    </Typography>
  );
}
